import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// `roles` is an optional whitelist; omit to allow any authenticated user.
const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-primary">
        <p className="text-text-secondary">Loading…</p>
      </div>
    );
  }
  if (user === false || !user.id) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
